export const NOTIFICATION_TEMPLATE_EDITOR_PATH = "/notification-templates/:id";
